var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49952 3.01338V0.499867C5.49943 0.223713 5.27552 -8.78654e-05 4.99936 2.58787e-08C4.85774 2.9323e-05 4.7228 0.060147 4.62799 0.165353L0.127974 5.1654C-0.0365885 5.34868 -0.0431804 5.62449 0.112476 5.81542L4.61252 11.3154C4.78737 11.5292 5.10237 11.5607 5.31612 11.3858C5.4319 11.2911 5.4992 11.1495 5.49952 10.9999V8.50843C9.44957 8.63693 11.9146 10.3254 13.0256 13.6585C13.0938 13.8624 13.2846 13.9999 13.4996 14C13.5266 14.0001 13.5535 13.9979 13.5801 13.9935C13.822 13.954 13.9996 13.7451 13.9996 13.5C13.9996 7.61191 10.4551 3.28637 5.49952 3.01338ZM4.99951 7.49991C4.72335 7.49991 4.49949 7.72377 4.49949 7.99992V9.59993L1.15797 5.51538L4.49952 1.80286V3.49986C4.49952 3.77602 4.72338 3.99987 4.99954 3.99987C8.92958 3.99987 11.8706 6.71941 12.7376 10.8689C11.1281 8.63092 8.53655 7.49991 4.99951 7.49991Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.8aada5591881dc53237d6364ac737951.svg";
export { ForwardRef as ReactComponent };